/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class SecurityInformation {
  /**
  * The type of evidence
  */
  'evidenceType'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "evidenceType",
      "baseName": "evidenceType",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SecurityInformation.attributeTypeMap;
  }

  public constructor() {
  }
}

